__turbopack_context__.v({
  "className": "RUp7uq_className",
  "variable": "RUp7uq_variable",
});
